module.exports = __webpack_public_path__ + "assets/vehicle.cde52971.svg";